import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <section
      id="home"
      className="relative pt-32 pb-24 overflow-hidden"
    >
      {/* Background images - light mode shows hero-combined-light, dark mode shows hero-combined-dark */}
      <div className="absolute inset-0 z-0">
        {/* Light mode background */}
        <div
          className="absolute inset-0 dark:hidden bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: 'url(/hero-combined-light.svg)' }}
        />
        {/* Dark mode background */}
        <div
          className="hidden dark:block absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: 'url(/hero-combined-dark.svg)' }}
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div>
          {/* Main Heading - Results First, per content strategy */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-neutral-900 dark:text-white mb-6 fade-in-up leading-tight">
            We help businesses achieve
            <span className="block text-primary-rose mt-2">real, measurable results</span>
          </h1>

          {/* Subheading - Focus on outcomes, not technology */}
          <p className="text-lg md:text-xl lg:text-2xl text-neutral-700 dark:text-neutral-200 mb-8 max-w-3xl fade-in-up animation-delay-100 leading-relaxed">
            From websites that convert to AI workflows that save time—we deliver digital solutions
            that grow your business. No jargon. No complexity. Just results.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 fade-in-up animation-delay-200">
            <Link to="/contact" className="btn-hover px-8 py-4 bg-primary-rose text-white rounded-lg font-semibold text-lg hover:bg-primary-rose/90 focus:outline-none focus:ring-2 focus:ring-primary-rose focus:ring-offset-2 transition-all inline-block text-center">
              Get Your Free Review
            </Link>
            <Link to="/services" className="btn-hover px-8 py-4 border-4 border-neutral-900 dark:border-2 dark:border-white text-neutral-900 dark:text-white hover:bg-neutral-900 dark:hover:bg-white hover:text-white dark:hover:text-primary-indigo rounded-lg font-semibold text-lg focus:outline-none focus:ring-2 focus:ring-neutral-900 dark:focus:ring-white focus:ring-offset-2 transition-all inline-block text-center">
              See What's Possible
            </Link>
          </div>
        </div>
      </div>

      {/* Wave decoration at bottom */}
      <div className="absolute bottom-0 left-0 right-0 z-10" aria-hidden="true">
        <svg
          viewBox="0 0 1200 120"
          fill="none"
          className="w-full h-16 md:h-20"
          preserveAspectRatio="none"
        >
          <path
            d="M0,60 C300,90 600,30 900,60 C1050,75 1150,45 1200,60 L1200,120 L0,120 Z"
            fill="currentColor"
            className="text-neutral-50 dark:text-neutral-dark-200"
          />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
